import { nextTick } from 'vue'
import loggedInUser from '@/state/loggedInUser'
import { navigateToUserInfo, navigateToPayment } from '@/router/navigate'
import optionsPageInvalidFields from '@/computed/optionsPageInvalidFields'
import stepValidity from '@/computed/stepValidity'
import showErrors from '@/state/showErrors'
// import scrollIntoView from 'smooth-scroll-into-view-if-needed'
import handleOpenInsurancePopup from '@/logic/handleOpenInsurancePopup'
import getQueryParams from '../utils/getQueryParams'
import assuranceAnnulationDecision from '@/state/assuranceAnnulationDecision'
import bookingQuoteResponse from "@/state/bookingQuoteResponse"

const handleReserveClick = async () => {
    if (!stepValidity.reserveStep.value.getFinalized()) {
        showErrors.value = true
        const selector = `#${[...optionsPageInvalidFields.value][0]}`
        const elem = document.querySelector(selector)
        if (!elem) throw new Error('element must exist')
        elem.scrollIntoView({
            behavior: 'smooth', 
            block: 'center',
            inline: 'nearest'
        });
        // await scrollIntoView(elem, {
        //     // scrollMode: 'if-needed',
        //     ease: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
        //     duration: 750,
        //     block: 'center',
        //     inline: 'nearest',
        // })
    } else {
        showErrors.value = false
        const params = getQueryParams()
        console.log("bookingQuoteResponse.value: ", bookingQuoteResponse.value)
        console.log("loggedInUser.value: ", loggedInUser.value)
        nextTick(() => {
            if (!assuranceAnnulationDecision.value) {
                handleOpenInsurancePopup()
                return
            }
            if (bookingQuoteResponse.value?.validUser && (loggedInUser.value || params.info)) {
                navigateToPayment()
            } else {
                navigateToUserInfo()
            }
        })
    }
}

export default handleReserveClick
